'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _Product = require('../Product');

var _SizeGuide = require('../SizeGuide');

var _SizeGuide2 = _interopRequireDefault(_SizeGuide);

var _VideoModal = require('../VideoModal');

var _VideoModal2 = _interopRequireDefault(_VideoModal);

var _util = require('./util');

var _Remodal = require('../Remodal');

var _Remodal2 = _interopRequireDefault(_Remodal);

var _legacy = require('./legacy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {};
var QuickView = {};
var selectors = {
  trigger: new _DataSelector2.default('data-quickview-trigger'),
  variantId: new _DataSelector2.default('data-variant-id'),
  handle: new _DataSelector2.default('data-handle'),
  entry: new _DataSelector2.default('data-quickview-modal-entry'),
  modal: new _DataSelector2.default('data-remodal-id'),
  atc: new _DataSelector2.default('data-add-to-cart')
};

var bindListeners = function bindListeners() {
  dom.triggers.forEach(function (el) {
    return el.addEventListener('click', openQuickView);
  });
};

var cacheDom = function cacheDom() {
  dom.triggers = selectors.trigger.nodes();
  dom.entry = selectors.entry.node();
  dom.modal = document.querySelector(selectors.modal.valueContains('quickview'));
};

var initDependencies = function initDependencies() {
  (0, _Product.init)();
  _SizeGuide2.default.init();
  _VideoModal2.default.init();
};

var setProductState = function setProductState(handle) {
  window.bvaccel.collection.quickviewHandle = handle;
  window.bvaccel.product.quickViewOpen = true;
};

/**
 * Public
 */
var openQuickView = function openQuickView(_ref) {
  var currentTarget = _ref.currentTarget;

  var handle = currentTarget.dataset[selectors.handle.key()];
  var type = currentTarget.dataset[selectors.trigger.key()];
  var variant = currentTarget.dataset[selectors.variantId.key()];

  if (!type) // only open for 'modal' or 'simple' types
    {
      return;
    }

  var uri = (0, _util.getQuickViewURI)(handle, type, variant);

  setProductState(handle);

  (0, _util.fetchPDP)(uri).then(function (html) {
    return dom.entry.innerHTML = html;
  }).then(initDependencies).then(function () {
    $(dom.modal).remodal().open();
  }).then(function () {
    /** close the modal when product is added to cart. */
    dom.modal.querySelector(selectors.atc.bracketed()).addEventListener('click', function () {
      $(dom.modal).remodal().close();
    });
  });
};

var close = function close() {
  if (dom.modal) {
    $(dom.modal).remodal().close();
  }
};

var init = function init() {
  cacheDom();
  bindListeners();
  _Remodal2.default.init({
    hashTracking: false
  });
  (0, _legacy.init)();
};

/**
 * @typedef QuickView
 * @method init
 * @method close
 */
QuickView.init = init;
QuickView.close = close;

exports.default = QuickView;